import React from 'react';
import { fontSans, headerButtonStyle } from './requestChangesStyles';

const PENDING_REVIEW_COPY = 'Your requested updates are reflected below. Our team will confirm product availability and review any schedule or scope changes that may affect pricing.';
const PENDING_REVIEW_CLOSING = 'We’ll give everything a final review before confirming your updates.';

const continueEditingStyle = {
  ...headerButtonStyle,
  height: 34,
  padding: '7px 14px',
  marginTop: 14,
  fontWeight: 500,
  letterSpacing: '0.06em'
};

export default function PendingReviewBanner({ onContinueEditing }) {
  return (
    <div
      className="no-print pending-review-banner"
      role="status"
      aria-label="Changes received"
      style={{
        width: '100%',
        boxSizing: 'border-box',
        backgroundColor: '#F4F2EC',
        borderBottom: '1px solid #e8e0d4',
        padding: '16px 24px 18px'
      }}
    >
      <div style={{ maxWidth: 720, margin: '0 auto' }}>
        <div style={{
          fontFamily: fontSans,
          fontSize: 11,
          fontWeight: 600,
          letterSpacing: '0.14em',
          textTransform: 'uppercase',
          color: '#2C2C2C',
          lineHeight: 1.2
        }}>
          Changes Received
        </div>
        <p style={{
          margin: '8px 0 0',
          fontFamily: fontSans,
          fontSize: 14,
          lineHeight: 1.55,
          color: '#4A4843'
        }}>
          {PENDING_REVIEW_COPY}
        </p>
        <p style={{
          margin: '8px 0 0',
          fontFamily: fontSans,
          fontSize: 13,
          lineHeight: 1.5,
          color: '#8a8378',
          fontStyle: 'italic'
        }}>
          {PENDING_REVIEW_CLOSING}
        </p>
        {onContinueEditing ? (
          <button
            type="button"
            onClick={onContinueEditing}
            style={continueEditingStyle}
          >
            Continue Editing
          </button>
        ) : null}
      </div>
    </div>
  );
}
